/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { BaseBlockContent } from "src/components/Block/styles";

export const StyledCodeBlockContent = styled(BaseBlockContent)`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;

export const codeEditorStyles = {
  fontSize: 14,
  fontFamily: "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
  width: "100%",
  minHeight: "100%",
  backgroundColor: "#eeedea",
  lineHeight: "20px",
};

export const StyledLanguage = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  color: #aeaeae;
  font-family: "IBM Plex Mono";
  font-size: 12px;
  padding: 5px;
`;
